import React from "react";
import { MessageCircle, ArrowRight } from "lucide-react";
import { waLink } from "../lib/contact";

export const About = () => {
  return (
    <section
      id="sobre"
      data-testid="about-section"
      className="relative py-16 md:py-24 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-6 relative order-2 lg:order-1">
            <div className="relative border-2 border-[#0f172a] overflow-hidden shadow-brutal">
              <img
                src="https://customer-assets.emergentagent.com/job_aluguel-cacambas-1/artifacts/poee7ikj_Captura%20de%20Tela%202026-05-10%20a%CC%80s%2008.54.40.png"
                alt="Caçamba real da PJ Caçambas em atendimento em Jundiaí"
                className="w-full h-[420px] md:h-[560px] object-cover"
                loading="lazy"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#0f172a]/80 to-transparent p-5">
                <p className="text-white font-extrabold uppercase tracking-wider text-sm md:text-base">
                  Caçamba PJ em operação · Jundiaí
                </p>
              </div>
            </div>
            <div className="absolute -top-6 -left-6 bg-[#fff505] border-2 border-[#0f172a] p-4 hidden md:block">
              <div className="font-display text-4xl text-[#0f172a] leading-none">
                +5.000
              </div>
              <div className="text-[11px] uppercase font-extrabold tracking-wider text-[#0f172a] mt-1">
                Caçambas entregues
              </div>
            </div>
          </div>

          <div className="lg:col-span-6 order-1 lg:order-2">
            <div className="inline-block px-3 py-1 bg-[#027ec3] text-white text-xs font-extrabold uppercase tracking-[0.2em] mb-4">
              Quem somos
            </div>
            <h2
              data-testid="about-title"
              className="font-display text-4xl sm:text-5xl md:text-6xl text-[#0f172a]"
            >
              PJ Caçambas de <span className="text-[#027ec3]">Entulho</span>
              <br />
              em <span className="bg-[#fff505] px-2">Jundiaí</span>
            </h2>
            <div className="mt-6 space-y-4 text-[#475569] text-base md:text-lg leading-relaxed font-medium">
              <p>
                A <strong className="text-[#0f172a]">PJ Caçambas de Entulho</strong>{" "}
                oferece soluções rápidas e eficientes para remoção de entulho em
                Jundiaí e Região. Trabalhamos com aluguel de caçambas para
                pequenas e grandes obras, reformas residenciais, construções,
                limpeza de terrenos e descarte de resíduos.
              </p>
              <p>
                Nosso compromisso é oferecer{" "}
                <strong className="text-[#0f172a]">atendimento ágil</strong>,{" "}
                <strong className="text-[#0f172a]">preço justo</strong> e{" "}
                <strong className="text-[#0f172a]">entrega rápida</strong> para
                atender exatamente o que sua obra precisa. Trabalhamos com
                descarte responsável e dentro das normas ambientais.
              </p>
            </div>

            <div className="mt-8 flex flex-wrap gap-3">
              <a
                href={waLink("Olá! Gostaria de saber mais sobre os serviços da PJ Caçambas.")}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="about-whatsapp-btn"
                className="inline-flex items-center gap-2 px-5 py-3 bg-[#0f172a] text-white font-bold uppercase text-sm border-2 border-[#0f172a] hover:bg-[#fff505] hover:text-[#0f172a] transition-colors"
              >
                <MessageCircle className="w-4 h-4" strokeWidth={3} />
                Falar no WhatsApp
                <ArrowRight className="w-4 h-4" strokeWidth={3} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
